import React from 'react';
import './style.scss';

export const LoadingSpinner: React.FC = () => {
  return (
    <div className="loading-spinner__container">
      <div className="loading-spinner__spinner" />
    </div>
  );
};

export default LoadingSpinner;
